import * as React from 'react';
import { useParams } from 'react-router-dom';

import { Workout } from 'base/api/types';
import { transformContentGoals } from 'base/api/utils';
import { STATUSES_OPTIONS } from 'common/consts';
import { PK } from 'common/types';
import { DetailsCard, DetailsSuspense } from 'templates/details';

import WorkoutCore from '../components/WorkoutCore';
import { fields, WorkoutFields } from '../consts';
import { useWorkoutDetails } from '../queries';

const transformWorkout = (raw: Workout): WorkoutFields => ({
  [fields.title.name]: raw.title,
  [fields.description.name]: raw.description,
  [fields.status.name]: STATUSES_OPTIONS.filter(({ value }) => value === raw.status),
  [fields.content_goals.name]:
    raw.content_goals && transformContentGoals(raw.content_goals),
  [fields.media_file_pk.name]: [raw.media_file],
  [fields.is_featured.name]: raw.is_featured,
  [fields.is_inspiration.name]: raw.is_inspiration,
});

const WorkoutDetails = () => {
  const { pk } = useParams<{ pk?: PK }>();
  const { data, ...query } = useWorkoutDetails(pk);
  const defaultValues = data && transformWorkout(data);

  return (
    <DetailsCard created={data?.created_at} lastUpdate={data?.modified_at}>
      <DetailsSuspense isLoading={query.isLoading} error={query.error}>
        <WorkoutCore pk={pk} defaultValues={defaultValues} />
      </DetailsSuspense>
    </DetailsCard>
  );
};

export default WorkoutDetails;
